import { useContext } from 'react'
import { NextBookingContext } from './NextBookingContext';

export const useNextBooking = () => useContext(NextBookingContext)